import { I18n } from "@assets/strings";
import { useObservable } from "micro-observables";
import React from "react";
import styled from "styled-components";
import { MaterialTextInput } from "@ui/components/inputs/materialTextInput";
import { useEditorController } from "@ui/pages/lms/courseEditorPage/courseEditorController/editorControllerContext";

type TitleEditorProps = React.HTMLAttributes<HTMLDivElement>;

export const TitleEditor: React.FC<TitleEditorProps> = ({ ...htmlProps }) => {
	const controller = useEditorController();
	const course = useObservable(controller.course);

	return (
		<BigTextInput
			{...htmlProps}
			placeholder={I18n.t("course.editor.title.placeholder") + "*"}
			value={course.title}
			onChange={(v) => controller.setTitle(v)}
		/>
	);
};

const BigTextInput = styled(MaterialTextInput)`
	input,
	input::placeholder {
		font-size: 1.875rem;
		font-weight: bold;
	}
`;
